// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"bdb03dab","372":"1a298d70","592":"0d42a2a1"}[chunkId] + ".chunk.js";
};